export default{"ppst":{},"ppwcHome":{}}